// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"310":"5b7fb250","320":"bff9021d","510":"c99d8ebd","999":"4e064871"}[chunkId] + ".chunk.css";
};